import _Debug from './Debug';
import _Persist from './Persist';
import _Languages from './Languages';
import _Colors from './Colors';

export const Debug = _Debug;
export const Persist = _Persist;
export const Languages = _Languages;
export const Colors = _Colors;
